module.exports = __webpack_public_path__ + "img/hashicon3.54e76359.svg";